export default {"src":"/_next/static/media/yz-plant.6096fdb6.svg","height":23,"width":19,"blurWidth":0,"blurHeight":0};